const answerValues = {
    2: {
        answers: [
            'Urban', 'Rural'
        ]
    },
    3: {
        answers: [
            'Yes', 'No'
        ]
    },
    4: {
        answers: [
            'Yes', 'No'
        ]
    },
    5: {
        answers: [
            'Yes', 'No', "Missing answer"
        ]
    },

    6: {
        answers: [
            "Lower income",
            "Middle-class",
            "Upper-class",
            "Prefer not to disclose",
            "Missing answer"
        ]
    },
    7: {
        answers: [
            "Male",
            "Female",
            "Non-binary",
            "Prefer not to disclose"
        ]
    },
    8: {
        answers: [
            "Children's rights",
            "Civil and political rights",
            "Corruption",
            "Privacy and cyber-activism",
            "Disability rights",
            "Economic, social and cultural rights",
            "Elections and good governance",
            "Environmental and land rights",
            "Girls' and women's rights",
            "Impunity and justice",
            "Indigenous rights",
            "LGBTI rights",
            "Migrants and minority rights",
            "Journalist",
            "Human rights defence lawyer",
            "Other"
        ]
    },
    9: {
        answers: [
            "No, there is no secure and effective access to independent justice.",
            "There is secure access, but it is not effective.",
            "To some extent there is secure and effective access to independent justice.",
            "Yes, there is secure and effective access to independent justice.",
            "I do not know."
        ]
    },
    10: {
        answers: [
            "No, complaints brought forward by HRDs are never investigated.",
            "Only some complaints are investigated, but are neither independent nor impartial.", 
            "Most complaints are investigated and assessed by national legal institutions, but there are some issues with efficiency and/or other limitations.",
            "Yes, complaints about HRDs' rights violations are independently and impartially investigated by competent national authorities.",
            "I do not know."
        ]
    },
    11: {
        answers: [
            "No, HRDs do not benefit from an effective remedy and full reparation in the event of a violation of their rights.",
            "HRDs benefit to some extent from a remedy and reparation in the event of a violation of their rights.",
            "HRDs benefit to a large extent from a remedy and reparation in the event of a violation of their rights.",
            "HRDs benefit from an effective remedy and full reparation in the event of a violation of their rights.",
            "I do not know.",
            "Missing answer"
        ]
    },
    12: {
        answers: [
            "Yes, human rights organisations are fully restricted through the association registration procedure. Applications may not be assessed ly or denied without reasonable grounds.",
            "Human rights organisations face severe restrictions through the association registration procedure.",
            "Human rights organisations face some restrictions through the association registration procedure.",
            "No, human rights organisations do not experience restrictions through the association registration procedure.",
            "I do not know."
        ]
    },
    13: {
        answers: [
            "Yes, HRDs or CSOs are completely constrained from accessing foreign funding.",
            "HRDs or CSOs are to a large extent constrained from accessing foreign funding.",
            "HRDs or CSOs are to some extent constrained from receiving foreign funding.",
            "No, HRDs or CSOs do not face any practical constraints when accessing foreign funding.",
            "I do not know."
        ]
    },
    14: {
        answers: [
            "Yes, HRDs and/or CSOs are always framed as foreign agents.",
            "HRDs and/or CSOs are often framed as foreign agents.",
            "HRDs and/or CSOs are sometimes framed as foreign agents.",
            "No, HRDs and/or CSOs are never framed as foreign agents.",
            "I do not know."
        ]
    },
    15: {
        answers: [
            "Yes, HRDs and/or CSOs must always seek prior permission from competent authorities in order to execute projects and activities.",
            "HRDs and/ or CSOs often need prior permission from competent authorities in order to execute projects and activities.",
            "HRDs and/or CSOs sometimes need prior permission from competent authorities in order to execute projects and activities.",
            "No, HRDs and/or CSOs do not need prior permission from competent authorities in order to execute projects and activities.",
            "I do not know."
        ]
    },
    16: {
        answers: [
            "No, HRDs are unable to operate outside of an organisation effectively and safely.",
            "HRDs who wish to operate outside of an organisation face severe constraints.",
            "HRDs who wish to operate outside of an organisation face some constraints.",
            "Yes, HRDs can operate outside of an organisation safely and effectively.",
            "I do not know."
        ]
    },
    17: {
        answers: [
            "Yes, HRDs from different backgrounds do not enjoy equal treatment.",
            "No, HRDs do not enjoy equal treatment and distinctions are made on almost all grounds.",
            "HRDs are to some extent treated equally with distinctions being made on numerous grounds.",
            "HRDs from different backgrounds are treated equally to some extent.",
            "HRDs are to a large extent treated equally with distinctions being made on very few grounds.",
            "Yes, HRDs enjoy equal treatment without distinction of any kind.",
            "I do not know.",
        ]
    },
    18: {
        answers: [
            "No, HRDs are not able to freely express their opinions and ideas about all human rights due to retaliation, censorship, or sanctions from the government.",
            "No, hardly any freedom of speech exists, and HRDs are subject to immediate and harsh intervention.",
            "HRDs are able to some extent to express their opinion without restrictions from the government.",
            "HRDs are able to a large extent to express their opinion without restrictions from the government.",
            "Yes, HRDs are able to freely express their opinions and ideas about all human rights without fear of retaliation, censorship, or sanctions from the government.",
            "Yes, freedom of expression is protected and HRDs are effectively able to discuss any topic."
        ]
    },
    19: {
        answers: [
            "Yes, blasphemy legislation is used to fully limit and obstruct the work of HRDs.",
            "Blasphemy legislation is often used to limit and obstruct the work of HRDs.",
            "Blasphemy legislation is sometimes used to limit and obstruct the work of HRDs.",
            "No, blasphemy legislation is not used to limit and obstruct the work of HRDs.",
            "I do not know.",
            "Missing answer"
        ]
    },
    20: {
        answers: [
            "Yes, defamation legislation is used to fully limit and obstruct the work of HRDs.",
            "Defamation legislation is used to limit and obstruct the work of HRDS to a large extent.",
            "Defamation legislation is used to limit and obstruct the work of HRDs to some extent.",
            "No, defamation legislation is not used to limit and obstruct the work of HRDs.",
            "I do not know."
        ]
    },

    21: {
        answers: [
            "No, freedom of religion is not respected by public authorities and HRDs are not allowed to freely express their religion or work on issues relating to freedom of religion.",
            "Freedom of religion is weakly respected by public authorities.",
            "HRDs are allowed to some extent to express their religion and work on issues relating to freedom of religion, but with considerable limitations.",
            "Freedom of religion is respected by public authorities to a certain extend.",
            "HRDs are allowed to a large extent to express their religion and work on issues relation to freedom of religion, with certain limitations.",
            "Yes, freedom of religion is fully respected by public authorities and HRDs are allowed to freely express their religion.",
            "I do not know."
        ]
    },
    22: {
        answers: [
            "No, freedom of foreign travel and emigration for HRDs is not respected, and HRDs are fully subject to restrictions by public authorities.",
            "Freedom of foreign travel and emigration for HRDs is to some extent respected as HRDs face numerous restrictions by public authorities.",
            "Freedom of foreign travel and emigration is to a large extent respected as HRDs face limited restrictions by public authorities.",
            "Yes, freedom of foreign travel and emigration by HRDs is fully respected by public authorities who do not impose any restrictions.",
            "I do not know."
        ]
    },
    23: {
        answers: [
            "No, HRDs are not allowed to move or establish residency freely.",
            "HRDs do not enjoy any freedom of domestic movement.",
            "HRDs enjoy to some extent freedom of domestic movement and residence, with numerous restrictions.",
            "HRDs generally enjoy freedom of domestic movement, but there are some restrictions.",
            "HRDs enjoy to a large extent freedom of domestic movement and residence, with limited restrictions.",
            "Yes, virtually all HRDs enjoy the freedom of domestic movement and residence, without any restrictions.",
            "I do not know."
        ]
    },
    24: {
        answers: [
            "No, torture of HRDs is practised systematically by State agents.",
            "Torture of HRDs by State agents occurs often.",
            "Torture of HRDs by State agents occurs in some cases.",
            "Yes, HRDs are free from torture by State agents and it’s practice is non-existent.",
            "I do not know."
        ]
    },
    25: {
        answers: [
            "Yes, HRDs constantly experience arbitrary or unlawful interference with their right to privacy.",
            "HRDs' right to privacy is interfered to a great extend.",
            "HRDs' right to privacy is interfered to a large extent.",
            "HRDs' right to privacy is interfered to some extend.",
            "No, HRDs do not experience arbitrary or unlawful interference with their right to privacy.",
            "I do not know."
        ]
    },
    26: {
        answers: [
            "No, associations are actively prevented or shut down by political or other forces.",
            "Associations are prevented or shut down to a large extent.",
            "Associations are prevented or shut down to a some extent.",
            "Yes, HRDs can form associations freely without any fear of constraints.",
            "I do not know."
        ]
    },
    27: {
        answers: [
            "No, public assemblies of HRDs are actively prevented or shut down by political or other forces.",
            "Assemblies of HRDs are often prevented or shut down.",
            "Assemblies of HRDs are sometimes prevented or shut down.",
            "Yes, HRDs can assemble freely without any fear of constraints.",
            "I do not know."
        ]
    },
    28: {
        answers: [
            "Yes, the media is entirely restricted by the government.", 
            "The media is restricted by the government to a large extend.", 
            "The media is restricted by the government to some extent.", 
            "No, there is complete freedom of the media.", 
            "I do not know."
        ]
    },
    29: {
        answers: [
            "No, no information held by public authorities is accessible to the public.",
            "HRDs have access to some information held by public authorities.",
            "HRDs can access a number of information held by public authorities.",
            "HRDs have access to information held by public authorities to a large extent.",
            "Yes, HRDs have access to all information held by public authorities.",
            "I do not know."
        ]
    },
    30: {
        answers: [
            "Yes, HRDs are regularly persecuted for disclosing information deemed to be officially secret.", 
            "HRDs are often persecuted for disclosing information deemed to be officially secret.", 
            "HRDs are occasionaly persecuted for disclosing information deemed to be officially secret.", 
            "No, HRDs are never persecuted for disclosing information deemed to be officially secret.", 
            "I do not know.",
            "Missing answer"
        ]
    },

    31: {
        answers: [
            "Yes, web media is entirely censored by the government.",
            "Web media is censored to a large extent.",
            "Web media is censored to some extent.",
            "No, web media is not censored.",
            "I do not know."
        ]
    },
    32: {
        answers: [
            "Yes, there is absolute media bias.",
            "Media bias and self-censorship by media parties occurs often.",
            "Media bias and self-censorship by media parties occurs occasionally.",
            "No, there is very little to no media bias and/or self-censorship by media parties.",
            "I do not know."
        ]
    },
    33: {
        answers: [
            "Yes, HRDs face societal discrimination to a full extent because of the work they do.",
            "HRDs face societal discrimination to a large extent because of the work they do.",
            "HRDs face societal discrimination to some extent because of the work they do.",
            "No, HRDs do not face societal discrimination because of the work they do.",
            "I do not know."
        ]
    },
    34: {
        answers: [
            "Yes, public morality fully limits or obstructs the work of HRDs.",
            "Public morality limits or obstructs the work of HRDs to a large extent.",
            "Public morality limits or obstructs the work of HRDs to some extent.",
            "No, there is no public morality that limits or obstructs the work of HRDs.",
            "I do not know."
        ]
    },
    35: {
        answers: [
            "Yes, HRDs and CSOs are always subject to financial restrictions due to interventions of non-state actors.",
            "HRDs and CSOs are often subject to financial restrictions due to interventions of  non-state actors.",
            "Yes, HRDs and CSOs are regularly subject to financial restrictions due to interventions of non-state actors.",
            "HRDs and CSOs are sometimes subject to financial restrictions due to interventions of  non-state actors.",
            "No, HRDs are never subject to financial restrictions due to interventions of  non-state actors.",
            "I do not know."
        ]
    },

    36: {
        answers: [
            "Yes, HRDs are always subject to intimidation and/or violent attacks by non-state actors.",
            "Yes, HRDs are frequently subject to intimidation and/or violent attacks by non-state actors.",
            "HRDs are often subject to intimidation and/or violent attacks by non-state actors.",
            "HRDs are sometimes subject to intimidation and/or violent attacks by non-state actors.",
            "No, HRDs are never subject to intimidation and/or violent attacks by non-state actors.",
            "I do not know."
        ]
    },
    37: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    38: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    39: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    40: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    41: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    42: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    43: {
        answers: [
            "Completely Agree",
            "Agree",
            "Neutral",
            "Disagree",
            "Completely Disagree",
            "Missing answer"
        ]
    },
    44: {
        answers: [
            "Yes, excessive force is commonly used against HRDs and/or their relatives.",
            "Excessive force is often used against HRDs and/or their relatives.",
            "Excessive force has been used in some cases against HRDs and/or their relatives.",
            "No, excessive force is never used against HRDs and/or their relatives.",
            "I do not know."
        ]
    },
    45: {
        answers: [
            "Yes, HRDs are regularly restricted or targeted based on anti-terrorist legislation.",
            "Several cases are known of HRDs being restricted or targeted based on anti-terrorist legislation.",
            "Some cases are known of HRDs being restricted or targeted based on anti-terrorist legislation.",
            "No, HRDs are never restricted or targeted based on anti-terrorist legislation.",
            "I do not know."
        ]
    },
    46: {
        answers: [
            "No, public authorities do not effectively implement any protection measures for HRDs that might be a target because of their work.",
            "Public authorities implement protection measures for HRDs to some extent, but it is not effective.",
            "Public authorities implement protection measures for HRDs to a large extent, but there are some limitations.",
            "Yes, public authorities effectively implement protection measures for HRDs that might be a target because of their work.",
            "I do not know."
        ]
    },
    47: {
        answers: [
            "No, the environment is not protected in practice.",
            "Some measures are taken to protect the environment, but these are minimal.",
            "The environment is to a large extent protected, but with exceptions.",
            "Yes, the environment is actively protected to a full extent.",
            "I do not know."
        ]
    },
    48: {
        answers: [
            "No, protection of the traditional rights of indigenous people is non-existent.",
            "There is some form of protection of indigenous people.",
            "Indigenous people are protected to a large extent, but exceptions are made.",
            "Yes, indigenous people are always protected.",
            "I do not know."
        ]
    },

    49: {
        answers: [
            "No, the State does not prevent or remedy land grabbing.",
            "The State prevents or remedies land grabbing to some extent.",
            "The State prevents or remedies land grabbing to a large extent.",
            "Yes, the State prevents or remedies land grabbing.",
            "I do not know."
        ]
    },
    50: {
        answers: [
            "No, the government does not protect HRDs against political killings.",
            "The government protects HRDs against political killings to some extent.",
            "The government protects HRDs against political killings to a large extent.",
            "Yes, the government actively and fully protects HRDs against political killings.",
            "I do not know."
        ]
    },
    51: {
        answers: [
            "Yes, HRDs regularly face forced eviction.",
            "HRDs often face evictions.",
            "HRDs sometimes face evictions.",
            "No, HRDs are never faced with forced eviction.",
            "I do not know."
        ]
    },
    52: {
        answers: [
            "No, the State does not apply a gender perspective nor address the particular situation and protection needs of particular groups of HRDs.",
            "Yes, HRDs of a different gender have completely different experiences.",
            "There are large differences between the experiences of HRDs of a different gender.",
            "There are some differences between the experiences of HRDs of a different gender.",
            "The State applies to some extent a gender perspective and addresses the particular situation and protection needs of particular groups of HRDs.",
            "The State applies to a large extent a gender perspective and addresses the particular situation and protection needs of particular groups of HRDs.",
            "Yes, the State applies a gender perspective and addresses the particular situation and protection needs of particular groups of HRDs.",
            "No, HRDs of a different gender have equal experiences.",
            "I do not know."
        ]
    },
    53: {
        answers: [
            "No, the State does not protect people who have a different sexual orientation.",
            "No, the State does not address the situation and protection needs of human rights defenders working on sexual orientation.",
            "No, the State differentiates the protection of people due to their sexual orientation.",
            "The State addresses to some extent the situation and protection needs of human rights defenders working on sexual orientation.",
            "The State to some extent protects people who have a different sexual orientation.",
            "The State addresses to a large extent the situation and protection needs of human rights defenders working on sexual orientation.",
            "The State to a large extent protects people who have a different sexual orientation.",
            "Yes, the State addresses the situation and protection needs of human rights defenders working on sexual orientation.",
            "Yes, the State protects people who have a different sexual orientation.",
            "I do not know."
        ]
    },
    

    55: {
        answers: [
            "Yes",
            "No"
        ]
    },
    56: {
        answers: [
            "Through work experience",
            "Through studies",
            "Personal Research",
            "Other"
        ]
    },
    57: {
        answers: [
            "Female",
            "Male",
            "Prefer not to disclose",
        ]
    },   
    58: {
        answers: [
            "There is no separation of powers and no independent judicial branch.",
            "There is a limited separation of powers and some independence of the judicial branch.",
            "Separation of powers and an independent judicial branch exists to a large extent.",
            "There is a full separation of powers and full independence of the judicial branch.",
            "Not applicable."
        ]
    },

    59: {
        answers: [
            "No, complaints brought forward by HRDs are neither investigated nor assessed.",
            "Only some complaints are investigated and/or assessed.",
            "Most complaints are investigated and assessed by competent national authorities, but there are some issues with efficiency and/or other limitations.",
            "Yes, complaints about HRDs' rights violations are impartially investigated and independently assessed by competent national authorities.",
            "Not applicable.",
            "Missing answer"
        ]
    },
    60: {
        answers: [
            "The legal framework does not provide for redress mechanisms for individuals who have experienced a human rights violation.",
            "The legal framework provides for limited redress mechanisms that are not accessible to everyone.",
            "The legal framework provides for redress mechanisms to a large extent, but there are some issues with accessibility or other limitations.",
            "The legal framework provides for redress mechanisms for everyone.",
            "Not applicable."
        ]
    },
    61: {
        answers: [
            "Yes, human rights organisations are fully restricted by legal obstacles in the association registration procedure.",
            "Human rights organisations are to a large extent restricted by legal obstacles in the association registration procedure.",
            "Human rights organisations are to some extent restricted by legal obstacles in the association registration procedure.",
            "No, there are no legal obstacles for the association registration of human rights organisations."
        ]
    },
    62: {
        answers: [
            "Yes, there are laws which fully restrict access to foreign funding.",
            "There are laws that to a large extent restrict access to foreign funding.",
            "There are laws that to some extent restrict access to foreign funding.",
            "No, there are no laws that restrict access to foreign funding.",
            "Not applicable."
        ]
    },
    63: {
        answers: [
            "Yes, there is legislation that always labels HRDs and/or CSOs with access to foreign resources as foreign agents.",
            "Yes, there is legislation that results in HRDs receiving foreign funding being labelled as foreign agents.",
            "There is legislation that allows to a large extent to frame HRDs and/or CSOs with access to foreign resources as foreign agents. ",
            "Under some circumstances, national legislation may result in HRDs and/or CSOs with access to foreign resources being labelled as foreign agents.",
            "No, the country’s legislation does not address foreign agents.",
            "No, the national legislation does not frame HRDs and/or CSOs with access to foreign resources as foreign agents.",
            "Not applicable."
        ]
    },
    64: {
        answers: [
            "Yes, there is legislation that require NGOs to seeks prior approval from government agencies to execute projects or activities.",
            "National legislation often requires HRDs and CSOs to seek prior approval from competent authorities in order to execute projects and activities.",
            "National legislation sometimes requires HRDs and/or CSOs to seek prior approval from competent authorities in order to execute projects and activities, dependent on circumstances.",
            "Under some circumstances, the country’s legislation may result in HRDs requiring NGOs to seeks prior approval from government agencies to execute projects or activities.",
            "No, national legislation does not require HRDs and/or CSOs to seek prior approval from competent authorities in order to execute projects and activities.",
            "Not applicable."
        ]
    },

    65: {
        answers: [
            "Yes, any activity outside of an organisation for human rights purposes is unlawful.",
            "Working to protect and promote human rights outside of an organisation is criminalised to a large extent.",
            "Working to protect and promote human rights outside of an organisation is criminalised to some extent.",
            "No, HRDs may operate without any form of registration or membership in an organisation.",
            "Not applicable."
        ]
    },
    66: {
        answers: [
            "No, HRDs are not equal under national legislation. There are full legal restrictions against certain groups, which causes great inequalities between HRDs.",
            "There is a considerable amount of legal restrictions against certain groups, which causes a certain degree of inequalities between HRDs.",
            "There are a few legal restrictions against certain groups, which causes some inequalities between HRDs.",
            "Yes, HRDs are equal under national legislation without distinction of any kind.",
            "Not applicable."
        ]
    },
    67: {
        answers: [
            "No, national legislation does not protect freedom of expression, and the expression of opinions and ideas is fully restricted.",
            "National legislation protects freedom of expression to some extent, but numerous topics are defined by the government as controversial and are not allowed to be discussed freely.",
            "There is some national legislation protecting the freedom of speech. A very limited number of topics, which are defined by the State as not controversial, is allowed to be freely discussed.",
            "National legislation protects freedom of expression to a large extent, but some topics are defined by the government as controversial and are not allowed to be publicly addressed.",
            "Yes, national legislation fully protects freedom of expression. One can even freely discuss more controversial topics."
        ]
    },
    68: {
        answers: [
            "Yes, there is national blasphemy legislation that provides for a legal basis to potentially limit and obstruct the work of HRDs fully.",
            "There is national blasphemy legislation that to a large extent provides for a legal basis to potentially limit and obstruct the work of HRDs.",
            "There is national blasphemy legislation with legal potential to restrict HRDs to some extent.",
            "No, there is no national blasphemy legislation that provides a legal basis to potentially limit and obstruct the work of HRDs.",
            "Not applicable.",
            "Missing answer"
        ]
    },
    69: {
        answers: [
            "Yes, there is defamation legislation that provides for a legal basis to potentially restrict the work of HRDs fully.",
            "There is defamationlegislation that to a large extent provides for a legal basis to potentiallyrestrict the work of HRDs.",
            "There is defamation legislation that provides for a legal basis to potentially restrict HRDs to some extent.",
            "No, there is no defamation legislation that provides for a legal basis to potentially restrict HRDs.",
            "Not applicable."
        ]
    },
    70: {
        answers: [
            "No, freedom of religion is not protected by national legislation, and individuals/groups are not allowed to choose, change and practice religion privately or in public.",
            "National legislation protects freedom of religion to some extent, but with considerable exceptions.",
            "National legislation protects freedom of religion to a large extent, with some limitations.",
            "Yes, there is national legislation ensuring the freedom of religion.",
            "Not applicable."
        ]
    },
    71: {
        answers: [
            "No, national legislation does not protect freedom of foreign travel and emigration for HRDs.",
            "National legislation protects to a some extent freedom of foreign travel and emigration for HRDs, but places numerous legal restrictions.",
            "National legislation ensures the freedom of foreign travel to a large extent.",
            "Yes, national legislation fully protects the freedom to travel.",
            "Not applicable."
        ]
    },
    72: {
        answers: [
            "No, national legislation does not protect freedom of domestic movement and residence for HRDs.",
            "National legislation protects to some extent freedom of domestic movement and residence for HRDs, but places numerous legal restrictions.",
            "National legislation protects to a large extent freedom of domestic movement and residence for HRDs, with limited legal restrictions.",
            "Yes, national legislation does ensure the freedom of domestic movement.",
            "Not applicable."
        ]
    },
    73: {
        answers: [
            "No, national legislation does not ensure freedom from torture, and torture is being practiced systematically.",
            "National legislation ensures freedom from torture to some extent, but torture is often being practiced.",
            "National legislation ensures freedom from torture to a large extent, but torture occurs in some cases.",
            "Yes, national legislation ensures freedom from torture, and torture is non-existent.",
            "Not applicable."
        ]
    },
    74: {
        answers: [
            "No, national legislation does not protect the right to privacy of HRDs.",
            "National legislation protects the right to privacy of HRDs to some extent.",
            "National legislation protects the right to privacy to a large extent.",
            "Yes, national legislation protects the right to privacy of HRDs.",
            "Not applicable."
        ]
    },




    75: {
        answers: [
            "No, freedom of association is not ensured by national legislation.",
            "National legislation ensures freedom of association to some extent.",
            "National legislation ensures freedom of association to a large extent.",
            "Yes, freedom of association is fully protected under national legislation.",
            "Not applicable."
        ]
    },
    76: {
        answers: [
            "No, freedom of assembly is not ensured by national legislation.",
            "Freedom of assembly is ensured to some extent.",
            "Freedom of assembly is ensured to a large extent.",
            "Yes, freedom of assembly is fully protected under national legislation.",
            "Not applicable."
        ]
    },
    77: {
        answers: [
            "No, national legislation does not ensure freedom of the media.",
            "National legislation ensures freedom of the media to some extent.",
            "National legislation ensures freedom of media to a large extent.",
            "Yes, freedom of the media is fully protected under national legislation.",
            "Not applicable."
        ]
    },
    78: {
        answers: [
            "No, national legislation does not guarantee the right to access information held by public authorities.",
            "National legislation guarantees the right to access information to some extent.",
            "National legislation guarantees the right to access information to a large extent.",
            "Yes, national legislation ensures the disclosure of all information.",
            "Not applicable."
        ]
    },
    79: {
        answers: [
            "There are no precise criteria for State information to be declared secret.",
            "There are some vague criteria for State information to be declared secret.",
            "There are criteria for State information to be declared secret, but sometimes information is still illegitimately classified as such.",
            "There are criteria for information to be declared secret, but this is still a bit vague.",
            "There are very precise criteria for State information to be declared secret or not.",
            "Not applicable."
        ]
    },
    80: {
        answers: [
            "Yes, the national legislation censors nearly all media content on the internet.",
            "There are national laws censoring certain media content on the internet to a large extent.",
            "There are national laws censoring certain media content on the internet to some extent.",
            "No, there are no national internet laws censoring web media.",
            "Not applicable."
        ]
    },
    81: {
        answers: [
            "Yes, government officials are always allowed to use excessive force against civilians.",
            "Government officials are often allowed to use excessive force against civilians.",
            "Government officials are sometimes allowed to use excessive force against civilians.",
            "No, government officials are never allowed to use excessive force against civilians.",
            "Not applicable."
        ]
    },
    82: {
        answers: [
            "Yes, anti-terrorist legislation exists that limits human rights to a full extent.",
            "Anti-terrorist legislation limits human rights to a large extent.",
            "Anti-terrorist legislation limits human rights to some extent.",
            "No, anti-terrorist legislation does not limit human rights.",
            "Not applicable."
        ]
    },
    83: {
        answers: [
            "No, national legislation does not obligate public authorities to effectively implement protection measures for HRDs. ",
            "There is no national legislation protecting HRDs.",
            "National legislation obligates to some extent public authorities to effectively implement protection measures for HRDs.",
            "National legislation obligates to a large extent public authorities to effectively implement protection measures for HRDs.",
            "Yes, national legislation obligates public authorities to effectively implement protection measures for HRDs.",
            "There is a full national legislative protection of HRDs.",
            "Not applicable."
        ]
    },
    84: {
        answers: [
            "No, environmental protection is not regulated under national legislation.",
            "National legislation regulates environmental protection to a large extent.",
            "National legislation regulates environmental protection to some extent.",
            "Yes, there is full and extensive national legislation ensuring environmental protection.",
            "Not applicable."
        ]
    },
    85: {
        answers: [
            "No, there is no national legislative protection of indigenous people.",
            "The national legislation ensures a limited protection of indigenous people.",
            "The national legislation protects the rights of indigenous people to a large extent.",
            "Yes, there is a full national legislative protection of the rights of indigenous people.",
            "Not applicable."
        ]
    },
    86: {
        answers: [
            "No, national legislation does not have adequate regulations for the prevention and remedy of land grabbing.",
            "National legislation has some regulations for the prevention and remedy of land grabbing.",
            "National legislation has to a large extent regulations for the prevention and remedy of land grabbing.",
            "Yes, national legislation has adequate regulations for the prevention and remedy of land grabbing.",
            "Not applicable."
        ]
    },
    87: {
        answers: [
            "No, national law does not protect HRDs from forced evictions.",
            "National law protects HRDs from forced evictions to some extent.",
            "National law protects HRDs from forced evictions to a large extent.",
            "Yes, HRDs enjoy full protection by national law from forced evictions.",
            "Not applicable."
        ]
    },
    88: {
        answers: [
            "No, national legislation does not apply a gender perspective nor a sensitivity to the particular situation and protection needs of particular groups.",
            "National legislation applies to some extent a gender perspective and a sensitivity to the particular situation and protection needs of particular groups.",
            "National legislation applies to a large extent a gender perspective and a sensitivity to the particular situation and protection needs of particular groups.",
            "Yes, national legislation applies a gender perspective and a sensitivity to the particular situation and protection needs of particular groups.",
            "No, national legislation applies equally to all people, regardless of their gender.",
            "Not applicable."
        ]
    },
    89: {
        answers: [
            "No, national legislation does not protect all people, and discriminates on the basis of sexual orientation.",
            "National legislation protects to some extent people without discrimination on the basis of sexual orientation.",
            "National legislation to a large extent protects people who have a different sexual orientation.",
            "Yes, national legislation fully protects people who have a different sexual orientation.",
            "Not applicable."
        ]
    }

    


}

export default answerValues